import {Component, OnInit} from '@angular/core';
import {AiAssistantService, AssistantDefinition} from '../../services/ai-assistant.service';
import {GlobalSettingsService, OrgSettingsKeys} from '../../../app-common/services/global-settings.service';
import {PleaseWaitService} from '../../../app-common/services/please-wait/please-wait.service';
import {AppService} from '../../../app-common/services/app/app.service';
import {ISelectOption} from '../../../_widget-library/fields/single-select/single-select.component';

@Component({
  selector: 'app-assistant-window',
  templateUrl: './assistant-window.component.html',
  styleUrls: ['./assistant-window.component.scss']
})
export class AssistantWindowComponent implements OnInit {
  collapsed: boolean = true;
  currentScreen: string = 'assistants';
  currentSelectedAssistant?: AssistantDefinition;

  settingsVisible: boolean = false;

  orgDesc: string = '';
  empDesc: string = '';
  custDesc: string = '';
  aiFocus: ISelectOption;

  aiFocusOptions: ISelectOption[] = [
    {value: 'speed', name: 'Speed', icon: 'far fa-bolt', color: '#ff9800'},
    {value: 'accuracy', name: 'Accuracy', icon: 'fas fa-bullseye', color: '#4caf50'},
    ];

  constructor(private aiAssistantService: AiAssistantService,
              private pleaseWaitService: PleaseWaitService,
              private appService: AppService,
              public globalSettingsService: GlobalSettingsService) {

  }

  get assistantsLoaded() {
    return !!this.aiAssistantService.assistants;
  }

  ngOnInit(): void {
    this.globalSettingsService.getSetting(OrgSettingsKeys.ORG_PURPOSE).then((desc) => {
      this.orgDesc = desc;
    });
    this.globalSettingsService.getSetting(OrgSettingsKeys.ORG_WORKERS).then((desc) => {
      this.empDesc = desc;
    });
    this.globalSettingsService.getSetting(OrgSettingsKeys.ORG_CUSTOMERS).then((desc) => {
      this.custDesc = desc;
    });
    let aiFocus = localStorage.getItem('ai-assistant-focus');
    if (!aiFocus) {
      aiFocus = 'speed';
    }
    this.aiFocus = this.aiFocusOptions.find((opt) => opt.value === aiFocus);
  }

  collapse() {
    if (this.collapsed) {
      this.aiAssistantService.confirmLicenseAgreement().then(() => {
        this.collapsed = false;
      }).catch(() => {
        this.collapsed = true;
        this.appService.showWarnMessage('You must accept the license agreement to use the AI assistant');
      });
    } else {
      this.collapsed = true;
    }
  }

  selectAssistant(assistant: AssistantDefinition) {
    if (!assistant) {
      this.currentSelectedAssistant = undefined;
      this.currentScreen = 'assistants';
      return;
    }
    this.currentSelectedAssistant = assistant;
    this.currentScreen = 'conversation';
  }

  onSettingsClick(ev) {
    ev.stopPropagation();
    this.settingsVisible = !this.settingsVisible;
  }

  saveSettings() {
    const pr1 = this.globalSettingsService.saveSetting(OrgSettingsKeys.ORG_PURPOSE, this.orgDesc);
    const pr2 = this.globalSettingsService.saveSetting(OrgSettingsKeys.ORG_WORKERS, this.empDesc);
    const pr3 = this.globalSettingsService.saveSetting(OrgSettingsKeys.ORG_CUSTOMERS, this.custDesc);
    this.pleaseWaitService.addToQueue();
    Promise.all([pr1, pr2, pr3]).then(() => {
      this.appService.showSuccessMessage('Settings saved successfully');
      localStorage.setItem('ai-assistant-focus', this.aiFocus.value);
    }).finally(() => {
      this.settingsVisible = false;
      this.pleaseWaitService.removeFromQueue();
    });
  }

  onBetaClick(event: MouseEvent) {
    const hasConfirmed = localStorage.getItem('ai-assistant-license-confirmed');
    if (hasConfirmed) {
      event.stopPropagation();
      this.aiAssistantService.showDisclaimer(false);
    }
  }
}
